import React from "react";

export default function IntroCard({ photoSrc = null, name = "Neha Koirala" }) {
  return (
    <div className="flex flex-col md:flex-row items-center text-center md:text-left gap-6 sm:gap-8 md:gap-10 mb-6 sm:mb-10">
      {/* Avatar */}
      <div className="flex-shrink-0 w-28 h-28 sm:w-36 sm:h-36 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-brand-cream2 shadow-lg">
        {photoSrc ? (
          <img
            src={photoSrc}
            alt="Neha Koirala"
            className="w-full h-full object-cover"
          />
        ) : (
          // Fallback placeholder
          <div className="w-full h-full bg-brand-dark flex items-center justify-center text-5xl">
            👩
          </div>
        )}
      </div>

      {/* Text */}
      <div>
        {/* Greeting line */}
        <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-brand-dark leading-snug">
          Hi 👋
        </p>

        {/* Main text */}
        <p className="text-lg sm:text-2xl md:text-3xl font-semibold text-brand-dark leading-snug mt-1">
          I'm a UI/UX designer – passionate about user friendly digital experiences.
        </p>
      </div>
    </div>
  );
}
